(function () {
  'use strict';
  const overseas = /guadeloupe|martinique|guiana|guyane|réunion|reunion|mayotte|polynésie|polynesia|new caledonia|nouvelle.calédonie|saint.*pierre|saint.*barth|saint.*martin|wallis|futuna|french southern/i;
  function estimate(country, postcode) {
    if (overseas.test(country) || (/^(fr|france)$/i.test(country) && /^(97|98)/.test(postcode))) return { title: 'Outre-mer : délai à confirmer', detail: 'Les délais de France métropolitaine ne s’appliquent pas à l’outre-mer. Contactez-nous avant de commander pour cette destination.' };
    if (/^(fr|france)$/i.test(country)) return { title: 'Livraison estimée : 3–5 jours', detail: 'Estimation pour la France métropolitaine, selon le pays et le code postal saisis. Préparation sous 24–72 heures ouvrées.' };
    return { title: 'Livraison estimée : 5–7 jours', detail: 'Estimation indicative pour les autres pays, selon le pays saisi. Préparation sous 24–72 heures ouvrées.' };
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { estimate };
  if (typeof document === 'undefined') return;
  document.querySelectorAll('[data-delivery-address-form]').forEach(form => {
    const dialog = form.closest('dialog');
    const result = dialog.querySelector('[data-delivery-result]');
    const error = form.querySelector('[data-delivery-error]');
    const map = dialog.querySelector('[data-delivery-map]');
    const intro = dialog.querySelector('[data-delivery-intro]');
    const loading = dialog.querySelector('[data-delivery-loading]');
    const back = dialog.querySelector('[data-delivery-back]');
    const heading = dialog.querySelector('[data-delivery-heading]');
    const tick = dialog.querySelector('[data-delivery-tick]');
    let pending = null;
    function editAddress(focus) {
      clearTimeout(pending);
      pending = null;
      dialog.setAttribute('aria-busy', 'false');
      form.hidden = false;
      intro.hidden = false;
      loading.hidden = true;
      result.hidden = true;
      back.hidden = true;
      map.replaceChildren();
      error.hidden = true;
      if (focus) form.elements.street.focus({ preventScroll: true });
    }
    back.addEventListener('click', () => editAddress(true));
    form.addEventListener('input', () => { error.hidden = true; });
    form.addEventListener('change', () => { error.hidden = true; });
    form.addEventListener('submit', event => {
      event.preventDefault();
      if (pending !== null || form.hidden || !form.reportValidity()) return;
      error.hidden = true;
      const values = Object.fromEntries(new FormData(form));
      const street = values.street.trim(), postcode = values.postcode.trim(), city = values.city.trim(), country = values.country.trim();
      if (!street || !postcode || !city || !country || (/^(fr|france)$/i.test(country) && !/^\d{5}$/.test(postcode))) {
        error.textContent = 'Renseignez une rue, une ville et un code postal complets. Pour la France, le code postal comporte 5 chiffres.';
        error.hidden = false;
        return;
      }
      const current = estimate(country, postcode);
      const query = [street, postcode, city, country].join(', ');
      back.hidden = false;
      loading.hidden = false;
      dialog.setAttribute('aria-busy', 'true');
      loading.focus({ preventScroll: true });
      form.hidden = true;
      intro.hidden = true;
      pending = setTimeout(() => {
        pending = null;
        if (!dialog.open) return;
        const frame = document.createElement('iframe');
        frame.title = 'Google Maps — adresse saisie';
        frame.referrerPolicy = 'no-referrer';
        frame.src = 'https://maps.google.com/maps?q=' + encodeURIComponent(query) + '&output=embed';
        map.replaceChildren(frame);
        dialog.querySelector('[data-delivery-estimate]').textContent = current.title;
        dialog.querySelector('[data-delivery-destination]').textContent = query;
        tick.hidden = !current.title.startsWith('Livraison estimée :');
        const detail = dialog.querySelector('[data-delivery-detail]');
        detail.hidden = !tick.hidden;
        detail.textContent = tick.hidden ? current.detail : '';
        loading.hidden = true;
        result.hidden = false;
        dialog.setAttribute('aria-busy', 'false');
        heading.focus({ preventScroll: true });
      }, 1000);
    });
    dialog.addEventListener('cancel', () => editAddress(false));
    dialog.addEventListener('close', () => { editAddress(false); form.reset(); });
  });
  document.querySelectorAll('[data-smooche]').forEach(page => {
    const gift = page.querySelector('[data-parcel-gift]');
    if (!gift) return;
    function syncGift(units) {
      if (!units?.length) return;
      gift.hidden = units.length !== 2;
      gift.parentElement.classList.toggle('sm-parcel-solo', units.length !== 2);
    }
    syncGift(page.smParcelSelection);
    page.addEventListener('sm:parcel-selection', event => syncGift(event.detail));
  });
}());
